export default __webpack_public_path__ + "static/media/SummJP.3dbb5802.jpg";